module.exports = __webpack_public_path__ + "static/media/Finnovex-Qatar-2025.a7246d8d.png";